module.exports = __webpack_public_path__ + "img/zs_4@2x.7f753d6a.png";